
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"21","viewBox":"0 0 19 21"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#324997","d":"M14.4 11.5H9.5v4.9h4.9v-4.9zM13.4.7v2H5.6v-2h-2v2H.7v17.6h17.6V2.7h-2.9v-2h-2zm3 17.6H2.6V7.6h13.7v10.7z"}})])
          )
        }
      }
    